export default __webpack_public_path__ + "img/glyphicons-halflings-white.png";